import React from 'react'
import CreditCard from '@images/credit_card.svg'


export default (props) =>
  <img {...props} src={CreditCard}></img>
